module.exports = __webpack_public_path__ + "img/horizontal_7_2_8023.abbb0152.png";